import React, { useEffect, useState } from "react";
import heroman from "../../../assets/images/heroman.png";
import Ourpartners from "./Ourpartners";
import Button from "../../../components/Resuseables/Button/Button";
import { Link } from "react-router-dom";
import BookDemoModal from "../../../components/Resuseables/BookDemoModal/BookDemoModal";

const Hero = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <section className="hero-container  w-full h-full flex flex-col ">
        <div className="relative flex items-center  gap-28 md:gap-0 flex-col md:flex-row justify-center pt-8  px-4  sm:px-10 xl:px-28 ">
          <div className="heroBox-1 relative w-full h-full flex flex-col items-center justify-center">
            <div
              className="heroBox1-content w-full   h-full   flex flex-col align-center justify-center  text-center md:text-left pb-10 md:pb-0"
              style={{ color: "#0050AE" }}
            >
              <div className="md:hidden flex w-full items-center justify-center ">
                <img
                  src={"/home/hero-mobile.png"}
                  alt=""
                  className=" top-0 left-0 w-[300px] self-center h-full"
                />
              </div>
              <div className="flex flex-col mt-6">
                <h1
                  style={{ lineHeight: "120%" }}
                  className="text-xl lg:text-4xl font-[600] "
                >
                  We Empower Businesses With Cutting Edge Communication Tools
                </h1>

                <p className="font-[300] text-xs md:text-sm text-[#000000] mt-[11px] mb-[45px]">
                  Welcome to SleengShort, your trusted partner for seamless
                  business communication. Whether you’re looking to send Bulk
                  SMS, run targeted SMS Campaigns, or leverage USSD technology,
                  we provide cutting-edge solutions to help you connect with
                  your audience effectively.
                </p>
              </div>

              <div>
                <button
                  onClick={() => setIsModalOpen(true)}
                  className="flex items-center gap-10 justify-center  md:justify-start"
                >
                  {/* <Button
                    btnText="Get started today"
                    btnBgColor="#7BCB2C"
                    btnColor="#fff"
                    btnRadius="10px"
                    btnPadding="16px 24px"
                    btnWidth="208px"
                    btnHeight="56px"
                  /> */}
                  <Button
                    btnText="Book a Demo"
                    btnBgColor="#7BCB2C"
                    btnColor="#fff"
                    btnRadius="10px"
                    btnPadding="16px 24px"
                    btnWidth="208px"
                    btnHeight="56px"
                  />
                </button>
              </div>
            </div>
          </div>

          <div className="heroBox-2 relative  h-full  w-full hidden md:block">
            <img src={heroman} alt="" />
          </div>
        </div>

        {/* <Ourpartners /> */}
      </section>

      <BookDemoModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
};

export default Hero;
